export default "__VITE_ASSET__DahIzLjL__"